//Angular
import { Observable } from "rxjs";
import { inject } from "@angular/core";
import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";

//Services
import { TranslationService } from "#services/translation/translation.service";

export const httpRequestInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const translationService = inject(TranslationService);

    const modifiedReq = req.clone({
        setHeaders: {
            Language: translationService.currentLanguage,
        },
    });

    return next(modifiedReq);
};
